import { useNavigate } from 'react-router-dom'
import Pagination from 'components/Pagination/Pagination'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'

const HubDeIa = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesAIAgent = [
    {
      id: 2,
      title: 'hubDeIa_page.relatedCases.items.leitorDePedidos.title',
      description: 'hubDeIa_page.relatedCases.items.leitorDePedidos.description',
      icon: '',
      url: 'leitor-de-pedidos',
    },
    {
      id: 3,
      title: 'hubDeIa_page.relatedCases.items.iaAssistenteDeManutencao.title',
      description: 'hubDeIa_page.relatedCases.items.iaAssistenteDeManutencao.description',
      icon: '',
      url: 'ia-assistente-de-manutencao',
    },
    {
      id: 4,
      title: 'hubDeIa_page.relatedCases.items.iaAssistenteRh.title',
      description: 'hubDeIa_page.relatedCases.items.iaAssistenteRh.description',
      icon: '',
      url: 'ia-assistente-rh',
    },
    {
      id: 5,
      title: 'hubDeIa_page.relatedCases.items.customerInsights.title',
      description: 'hubDeIa_page.relatedCases.items.customerInsights.description',
      icon: '',
      url: 'customer-insights',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('hubDeIa_page.relatedCases.cta')

    trackCtaClick({
      cta_name: 'ia_case_related_case_click',
      cta_location: 'ia_case',
      page_name: 'hub_de_ia',
      case_title: caseItem.title,
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })

    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container DataCases">
      <header className="main-container-top">
        <div className="text">
          <h2>{t('hubDeIa_page.header.title')}</h2>
        </div>
        <div className="image-container">
          <img
            src="/assets/Cases/DataCases/notebook-datacase2.png"
            alt={t('hubDeIa_page.header.imageAlt')}
          />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h3 className="NoBorder">{t('hubDeIa_page.sections.challenge.title')}</h3>
          <ul>
            <li>{t('hubDeIa_page.sections.challenge.items.item1')}</li>
            <li>{t('hubDeIa_page.sections.challenge.items.item2')}</li>
            <li>{t('hubDeIa_page.sections.challenge.items.item3')}</li>
            <li>{t('hubDeIa_page.sections.challenge.items.item4')}</li>
          </ul>

          <hr />

          <h3>{t('hubDeIa_page.sections.approach.title')}</h3>
          <ul>
            <li>{t('hubDeIa_page.sections.approach.items.item1')}</li>
            <li>{t('hubDeIa_page.sections.approach.items.item2')}</li>
            <li>{t('hubDeIa_page.sections.approach.items.item3')}</li>
            <li>{t('hubDeIa_page.sections.approach.items.item4')}</li>
            <li>{t('hubDeIa_page.sections.approach.items.item5')}</li>
            <li>{t('hubDeIa_page.sections.approach.items.item6')}</li>
          </ul>

          <hr />

          <h3>{t('hubDeIa_page.sections.result.title')}</h3>
          <ul>
            <li>{t('hubDeIa_page.sections.result.items.item1')}</li>
            <li>{t('hubDeIa_page.sections.result.items.item2')}</li>
            <li>{t('hubDeIa_page.sections.result.items.item3')}</li>
          </ul>

          {/*
          <div className="DataHashtag">
            <button>Data Engineering</button>
            <button>GEN IA</button>
            <button>Full Stack development</button>
            <button>UX</button>
          </div>
          */}
        </div>
      </div>

      <section className="main-cases-container">
        <h2 className="title">{t('hubDeIa_page.relatedCases.title')}</h2>
        <span className="subtitle">{t('hubDeIa_page.relatedCases.subtitle')}</span>

        <Pagination data={casesAIAgent} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span className="icon">{caseItem.icon}</span>
                  <h3>{t(caseItem.title)}</h3>
                  <p>{t(caseItem.description)}</p>
                  <a
                    href={caseItem.link}
                    onClick={() => handleRelatedCaseCtaClick(caseItem)}
                  >
                    {t('hubDeIa_page.relatedCases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default HubDeIa
